import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2d33e65c = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _6cb481ca = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _d9202826 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _58182c91 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _77756931 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _3fd84fb6 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _28aa93ba = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _23cc9b84 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7084e547 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _16705d30 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _3ce15f88 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _54931dd4 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _87e8d34c = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _64f4749e = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _777ba769 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _ae6407d8 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _042e8dfb = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _2a33a91e = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _41f922ca = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _433c722a = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _55e3bd1b = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _d924bb3e = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _d9ba5356 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _90a79210 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _954fbc84 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _536bd027 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _4f916d29 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _5b4c6df9 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _1785f7d2 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _ae8b5c9e = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _41d347e8 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _6c75dd25 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _1dd60f84 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _46948b88 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _24608c04 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _725839b4 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _7c5ebb41 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _51443ec6 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _32c198fe = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _0ec00362 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _3fe8e862 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _7b8959ca = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _e0c9d378 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _32bfc969 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _8f75e3a8 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _38bbc8b8 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _5c23fc62 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _baef2b08 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _1c3c2ef8 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _098fb7f0 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _61f69877 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _2bdbeebf = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _183ca080 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _3b5153b2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _fe961236 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _367e884a = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _fe0d6ace = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _779e2826 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _249a5602 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _3de56eea = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _cc57f664 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _3640cabe = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _3fea22ec = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _fcb5c8b8 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _473499e9 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _0b55c88c = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _d01bf4d6 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _2a50268d = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0efe03d9 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _4cc98d6f = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _08279cb8 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _3409b4ca = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _cfb7acc4 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _2328438c = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _87ca7f28 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _5836853c = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _2d33e65c,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _6cb481ca,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _d9202826,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _58182c91,
    name: "calendar"
  }, {
    path: "/customer",
    component: _77756931,
    name: "customer"
  }, {
    path: "/details",
    component: _3fd84fb6,
    name: "details"
  }, {
    path: "/goals",
    component: _28aa93ba,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _23cc9b84,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7084e547,
    name: "media"
  }, {
    path: "/privacy",
    component: _16705d30,
    name: "privacy"
  }, {
    path: "/project",
    component: _3ce15f88,
    name: "project"
  }, {
    path: "/response",
    component: _54931dd4,
    name: "response"
  }, {
    path: "/sale",
    component: _87e8d34c,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _64f4749e,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _777ba769,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _ae6407d8,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _042e8dfb,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _2a33a91e,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _41f922ca,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _433c722a,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _55e3bd1b,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _d924bb3e,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _d9ba5356,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _90a79210,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _954fbc84,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _536bd027,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _4f916d29,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _5b4c6df9,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _1785f7d2,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _ae8b5c9e,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _41d347e8,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _6c75dd25,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _1dd60f84,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _46948b88,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _24608c04,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _725839b4,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _7c5ebb41,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _51443ec6,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _32c198fe,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _0ec00362,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _3fe8e862,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _7b8959ca,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _e0c9d378,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _32bfc969,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _8f75e3a8,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _38bbc8b8,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _5c23fc62,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _baef2b08,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _1c3c2ef8,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _098fb7f0,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _61f69877,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _2bdbeebf,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _183ca080,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _3b5153b2,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _fe961236,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _367e884a,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _fe0d6ace,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _779e2826,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _249a5602,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _3de56eea,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _cc57f664,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _3640cabe,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _3fea22ec,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _fcb5c8b8,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _473499e9,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _0b55c88c,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _d01bf4d6,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _2a50268d,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0efe03d9,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _4cc98d6f,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _08279cb8,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _3409b4ca,
    name: "property-property",
    children: [{
      path: "contact",
      component: _cfb7acc4,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _2328438c,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _87ca7f28,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _5836853c,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
